// ❌ PROBLEMA ATUAL - Lines 50-65
// Esta função é chamada a cada render e faz múltiplas chamadas watch()
/*
const getCurrentStepLabel = () => {
  if (flowIndex !== null) {
    const currentFlows = watch("specialFlows") || [];
    if (currentFlows[flowIndex] && currentFlows[flowIndex].steps) {
      const currentStep = currentFlows[flowIndex].steps.find(
        (s) => s.id === step.id
      );
      return currentStep?.label || step.label;
    }
  } else {
    const currentSteps = watch("defaultFlowSteps") || [];
    if (currentSteps[index]) {
      return currentSteps[index].label || step.label;
    }
  }
  return step.label;
};

const stepLabel = getCurrentStepLabel();
*/

// ✅ SOLUÇÃO OTIMIZADA - SUBSTITUIR POR ISSO:
import { IconGripVertical, IconTrash, IconWand } from "@tabler/icons-react";
import { memo, useEffect, useRef, useMemo, useState } from "react";
import { Accordion, Button, Form } from "react-bootstrap";
import Select from "react-select";

const DynamicFlowStepComponent = memo(
  ({
    step,
    index,
    flowType,
    flowIndex = null,
    register,
    watch,
    setValue,
    handleAIFill,
    ImageSelect,
    NEXT_STEP_OPIONS,
    flowMode = "advanced",
    onRemove,
    canRemove = true,
  }) => {
    const [isExpanded, setIsExpanded] = useState(index === 0);
    const isInitializedRef = useRef(false);
    const userChangedRef = useRef(false);

    // ✅ SOLUÇÃO: Estados locais para performance
    const [localTextareaValue, setLocalTextareaValue] = useState("");
    const [localLabelValue, setLocalLabelValue] = useState("");

    const stepKey =
      flowIndex !== null
        ? `specialFlows.${flowIndex}.${step.key}`
        : `defaultFlow.${step.key}`;

    const nextStepKey =
      flowIndex !== null
        ? `specialFlows.${flowIndex}.${step.key}NextStep`
        : `defaultFlow.${step.key}NextStep`;

    // ✅ SOLUÇÃO: Obter valores apenas quando necessário
    const stepValue = watch(stepKey);
    const nextStepValue = watch(nextStepKey);

    // ✅ SOLUÇÃO: useMemo sem watch() nas dependências
    const stepLabel = useMemo(() => {
      if (localLabelValue) return localLabelValue;

      if (flowIndex !== null) {
        const currentFlows = watch("specialFlows") || [];
        if (currentFlows[flowIndex]?.steps) {
          const currentStep = currentFlows[flowIndex].steps.find(
            (s) => s.id === step.id
          );
          return currentStep?.label || step.label;
        }
      } else {
        const currentSteps = watch("defaultFlowSteps") || [];
        if (currentSteps[index]) {
          return currentSteps[index].label || step.label;
        }
      }
      return step.label;
    }, [localLabelValue, flowIndex, step.id, step.label, index]);

    // ✅ SOLUÇÃO: Inicializar valores locais
    useEffect(() => {
      if (!isInitializedRef.current) {
        const currentValue = watch(stepKey);
        const currentNextStep = watch(nextStepKey);

        setLocalTextareaValue(currentValue || "");
        setLocalLabelValue(stepLabel);

        if (currentValue === undefined || currentValue === null) {
          setValue(stepKey, "", { shouldValidate: false, shouldDirty: false });
        }
        if (currentNextStep === undefined || currentNextStep === null) {
          setValue(nextStepKey, "", {
            shouldValidate: false,
            shouldDirty: false,
          });
        }

        isInitializedRef.current = true;
      }
    }, [stepKey, nextStepKey, setValue, watch, stepLabel]);

    // ✅ SOLUÇÃO: Handler otimizado para textarea
    const handleTextareaChange = (e) => {
      setLocalTextareaValue(e.target.value);
    };

    // ✅ SOLUÇÃO: Sincronizar com formulário apenas no blur
    const handleTextareaBlur = (e) => {
      setValue(stepKey, e.target.value, {
        shouldValidate: false,
        shouldDirty: true,
      });
    };

    // ✅ SOLUÇÃO: Handler otimizado para label
    const handleLabelChange = (e) => {
      const newLabel = e.target.value;
      setLocalLabelValue(newLabel);
    };

    // ✅ SOLUÇÃO: Sincronizar label apenas no blur
    const handleLabelBlur = (e) => {
      const newLabel = e.target.value;
      userChangedRef.current = true;

      if (flowIndex !== null) {
        const currentFlows = watch("specialFlows") || [];
        if (currentFlows[flowIndex]?.steps) {
          const updatedFlows = [...currentFlows];
          const stepIndex = updatedFlows[flowIndex].steps.findIndex(
            (s) => s.id === step.id
          );
          if (stepIndex !== -1) {
            updatedFlows[flowIndex].steps[stepIndex] = {
              ...updatedFlows[flowIndex].steps[stepIndex],
              label: newLabel,
            };
            setValue("specialFlows", updatedFlows, {
              shouldValidate: false,
              shouldDirty: true,
            });
          }
        }
      } else {
        const currentSteps = watch("defaultFlowSteps") || [];
        const updatedSteps = [...currentSteps];
        if (updatedSteps[index]) {
          updatedSteps[index] = { ...updatedSteps[index], label: newLabel };
          setValue("defaultFlowSteps", updatedSteps, {
            shouldValidate: false,
            shouldDirty: true,
          });
        }
      }

      setTimeout(() => {
        userChangedRef.current = false;
      }, 100);
    };

    const circleColor =
      flowType === "special"
        ? "bg-warning text-white"
        : "bg-primary text-white";

    return (
      <Accordion className="mb-3">
        <Accordion.Item eventKey={step.id}>
          <Accordion.Header onClick={() => setIsExpanded(!isExpanded)}>
            <div className="d-flex align-items-center justify-content-between w-100 me-3">
              <div className="d-flex align-items-center">
                <IconGripVertical className="me-2 text-muted" size={16} />
                <div
                  className={`rounded-circle ${circleColor} d-flex align-items-center justify-content-center me-3`}
                  style={{ width: "32px", height: "32px", fontSize: "14px" }}
                >
                  {index + 1}
                </div>
                <div className="d-flex align-items-center">
                  <span className="me-2" style={{ fontSize: "18px" }}>
                    {step.icon}
                  </span>
                  <strong>{stepLabel}</strong>
                </div>
              </div>
              {canRemove && (
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemove();
                  }}
                >
                  <IconTrash size={14} />
                </Button>
              )}
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <div className="mb-4 pb-4">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center">
                  <div>
                    <h6 className="mb-1 d-flex align-items-center">
                      <span className="me-2">{step.icon}</span>
                      {/* ✅ SOLUÇÃO: Controlled component com onChange/onBlur */}
                      <Form.Control
                        type="text"
                        size="sm"
                        style={{ width: "200px" }}
                        placeholder={step.label}
                        value={localLabelValue || stepLabel}
                        onChange={handleLabelChange}
                        onBlur={handleLabelBlur}
                      />
                    </h6>
                    <small className="text-muted">{step.description}</small>
                  </div>
                </div>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => handleAIFill(stepKey, step)}
                >
                  <IconWand className="me-1" size={14} />
                  {flowMode === "basic" ? "Preencher com IA" : "IA"}
                </Button>
              </div>

              <Form.Group className="mb-3">
                {/* ✅ SOLUÇÃO: Controlled component com onChange/onBlur */}
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={localTextareaValue}
                  onChange={handleTextareaChange}
                  onBlur={handleTextareaBlur}
                  placeholder={
                    flowMode === "basic"
                      ? step.placeholder ||
                        `O que o agente deve falar na etapa "${stepLabel.toLowerCase()}"?`
                      : `Digite o texto para ${stepLabel.toLowerCase()}...`
                  }
                  style={{ fontSize: "14px" }}
                />
                {flowMode === "basic" && step.placeholder && (
                  <Form.Text className="text-muted">
                    💡 Exemplo: {step.placeholder}
                  </Form.Text>
                )}
              </Form.Group>

              <ImageSelect
                value={stepValue}
                onChange={(value) => setValue(stepKey, value)}
                placeholder="Adicionar uma imagem (opcional)"
                fieldName={stepKey}
              />

              {flowMode === "advanced" && (
                <Form.Group>
                  <Form.Label>Próxima Etapa</Form.Label>
                  <Select
                    options={NEXT_STEP_OPIONS}
                    placeholder="Selecione a próxima etapa..."
                    value={NEXT_STEP_OPIONS.find(
                      (opt) => opt.value === nextStepValue
                    )}
                    onChange={(selected) =>
                      setValue(nextStepKey, selected?.value || "")
                    }
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        minHeight: "38px",
                        borderColor: state.isFocused ? "#86b7fe" : "#dee2e6",
                        boxShadow: state.isFocused
                          ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)"
                          : "none",
                        "&:hover": { borderColor: "#b0b8c1" },
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        color: "#6c757d",
                      }),
                    }}
                  />
                </Form.Group>
              )}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  }
);

DynamicFlowStepComponent.displayName = "DynamicFlowStepComponent";
export default DynamicFlowStepComponent;
